import { Button, Icon, Modal } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { useState, useMemo, useRef, useEffect } from "react"
import WeeklyPrevIcon from "components/icons/WeeklyPrevIcon"
import WeeklyNextIcon from "components/icons/WeeklyNextIcon"
import { useTreasureHunt } from "components/useTreasureHunt/useTreasureHunt"
import timezones from "layouts/calendar/data/timezone"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import moment from "moment"
import "./custom.css"
import { useMaterialUIController } from "context"
import { useWeeklyCalendar } from "./hooks/useWeeklyCalendar"
import {
  calendarContainer,
  calendarDayBottomHeader,
  calendarDayHeader,
  calendarDayTopHeader,
  calendarHeader,
  calendarSlotLabel,
  calendarTabMenu,
  calendarTabMenuItem,
  calendarTabMenuItemTitle,
  calendarTitle,
  dayCellStyle,
  calendarTabMenuItemNote,
} from "./style"
import axios from "axios"
import { globalConfigs } from "configs"
// /Users/tueho/Documents/apollo2-frontend/src/shared/redux/api/index.js
import modalCalendarIcon from "assets/images/apollo-english/calendar-modal.png"
import { titleTypography } from "shared/styles/style"
import { descriptionTypography } from "shared/styles/style"
import { noteTypography } from "shared/styles/style"
import { useNavigate } from "react-router-dom"
import { useCreateLeaveRequestMutation } from "shared/redux/endpoints/leaveRequest"
import { useGetHubMutation } from "shared/redux/endpoints/sso"
import { ToastUtil } from "utilities/toastUtil"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import makeStyles from "pages/style"

import { useDispatch, useSelector } from "react-redux"
import { TypeClassSession } from "constant/TypeClassSession"

// Utils
import { enUS } from "date-fns/locale"
// Components - Modal
import ModalWorkShop from "components/ModalWorkShop/ModalWorkShop"
import ModalLeaveApplication from "components/ModalLeaveApplication/ModalLeaveApplication"
import ModalLeaveAlert from "components/ModalLeaveAlert/ModalLeaveAlert"
import ModalLeaveSubmitStatus from "components/ModalLeaveSubmitStatus/ModalLeaveSubmitStatus"
import ModalLeaveRelatedInfomation from "components/ModalLeaveRelatedInfomation/ModalLeaveRelatedInfomation"
import ModalMyCalendarStudentAtRisk from "components/ModalMyCalendarStudentAtRisk/ModalMyCalendarStudentAtRisk"
import { useLazyGetLeaveCalenDarQuery } from "shared/redux/endpoints/lxo"
import { useUploadFileMutation } from "shared/redux/endpoints/employee"
import {
  pickUploadFiles,
  mapUploadedToDtoAttachments,
  mapExistingUrlToDtoAttachments,
} from "shared/utils/common"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  outline: 0,
  padding: 3,
  maxWidth: 400,
}

const viewOptions = [
  { label: "Week", value: "timeGridWeek" },
  { label: "Month", value: "dayGridMonth" },
]

function WeeklyCalendar(props) {
  const dispatch = useDispatch()
  const {
    outerDate,
    dataWorkShop,
    onChangeTab,
    leaveData: leaveDataProp,
    setStart: setStartProp,
    setEnd: setEndProp,
  } = props

  const classes = makeStyles()
  const [getHub] = useGetHubMutation()
  const [title, setTitle] = useState("")
  const [data, setData] = useState({})
  const [isOpen, setOpen] = useState(false)

  /* extend */
  const [payloadSubmit, setPayloadSubmit] = useState({})
  const [isSubmitSuccess, setIsSubmitSuccess] = useState(false)
  const [isOpenModalLeave, setIsOpenModalLeave] = useState(false)
  const [isOpenModalLeaveAlert, setIsOpenModalLeaveAlert] = useState(false)
  const [isOpenModalLeaveAlertHoliday, setIsOpenModalLeaveAlertHoliday] =
    useState(false)
  const [isOpenModalLeaveSubmitStatus, setIsOpenModalLeaveSubmitStatus] =
    useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const { triggerIfNew } = useTreasureHunt("teacher-calendar-open-leave-modal")

  const [
    isOpenModalLeaveRelatedInformation,
    setIsOpenModalLeaveRelatedInformation,
  ] = useState(false)
  const [dataModalLeave, setDataModalLeave] = useState({})
  const [dataRelatedInformation, setDataRelatedInformation] = useState([])

  const [createLeaveRequest] = useCreateLeaveRequestMutation()

  const [triggerCalendarLeave, { data: leaveData }] =
    useLazyGetLeaveCalenDarQuery()
  /* end extend */

  const calendarRef = useRef(null)

  const [constroller] = useMaterialUIController()

  const { miniSidenav } = constroller

  const {
    events,
    eventsByDay,
    handleChangeDate,
    tab,
    setTab,
    loading,
    timezone,
    setTimeZone,
    tabs,
  } = useWeeklyCalendar(dataWorkShop)

  const syncRange = (startDate, endDate) => {
    if (!startDate || !endDate) return
    handleChangeDate(
      moment(startDate).format("DD-MM-YYYY"),
      moment(endDate).format("DD-MM-YYYY")
    )
    if (setStartProp && setEndProp) {
      setStartProp(moment(startDate).format("YYYY-MM-DD"))
      setEndProp(moment(endDate).format("YYYY-MM-DD"))
    }
  }

  const tabValue = useMemo(() => tab.value, [tab])
  const params = new URLSearchParams(location.search)
  const [view, setView] = useState("timeGridWeek") // dayGridMonth | timeGridWeek
  const [isActiveDayOff, setIsActiveDayOff] = useState(false)
  const user = useSelector((state) => state.auth.user)
  const { userId } = user
  const [uploadFile] = useUploadFileMutation()
  const lastWeekDateRef = useRef(null)
  const currentMonthRef = useRef(null)
  const monthAnchorDateRef = useRef(null)

  const onChangeViewOption = (value) => {
    if (value === view) return
    const api = calendarRef.current?.getApi()
    const currentDate = api?.getDate()
    let changeDate = null
    if (value === "timeGridWeek") {
      if (
        lastWeekDateRef.current &&
        currentMonthRef.current &&
        moment(lastWeekDateRef.current).format("YYYY-MM") ===
          currentMonthRef.current
      ) {
        changeDate = lastWeekDateRef.current
      } else {
        changeDate =
          monthAnchorDateRef.current ||
          (currentDate ? moment.utc(currentDate).format("YYYY-MM-DD") : null)
      }
    } else if (currentDate) {
      changeDate = currentDate
    }
    setView(value)
    setIsActiveDayOff(value === "dayGridMonth")
    if (changeDate) {
      api?.changeView(value, changeDate)
      if (typeof changeDate === "string") {
        setDate(changeDate)
      } else {
        setDate(moment.utc(changeDate).format("YYYY-MM-DD"))
      }
    } else {
      api?.changeView(value)
    }
    api?.render()
  }

  useEffect(() => {
    triggerCalendarLeave({
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      endDate: moment().endOf("month").format("YYYY-MM-DD"),
    })
  }, [])

  const openNewLms = async (options) => {
    const { userId, type = "LESSON_DETAIL", hubClassSessionId } = options

    try {
      const res = await axios.post(
        globalConfigs.urlSSOLms + "/auth/redirect-my-apollo/generate",
        {
          hubUserId: userId,
          type: type === "TEACHER" ? "TEACHER_SCHEDULE" : type,
          ...(type === "LESSON_DETAIL" && { hubClassSessionId }),
        },
        {
          headers: {
            "x-api-key": globalConfigs.apiKeySSO,
          },
        }
      )

      const redirectLink = res && res.data && res.data.redirectLink
      if (redirectLink) {
        window.open(redirectLink, "_blank")
      } else {
        ToastUtil.showToastError("Can't open LMS. Please try again")
      }
    } catch (err) {
      console.log(err)
      ToastUtil.showToastError("Can't open LMS. Please try again")
    }
  }

  const handleOpenLms = async (options) => {
    const { data, userId, type } = options

    const id = data?.id
    if (!id) return

    await openNewLms({
      hubClassSessionId: id,
      userId: userId,
      type,
    })
  }

  const onClickForDayGridMonth = (isActiveDayOff) => {
    if (isActiveDayOff) {
      if (isActiveDayOff) {
        setDataModalLeave(isActiveDayOff)
        triggerIfNew()
        setIsOpenModalLeave(true)
      }
    }
  }

  useEffect(() => {
    calendarRef?.current?.getApi?.()?.gotoDate?.(outerDate)
    if (view === "timeGridWeek") {
      const rangeStart = moment(outerDate, "YYYY-MM-DD").startOf("isoweek")
      const rangeEnd = moment(outerDate, "YYYY-MM-DD").endOf("isoWeek")
      syncRange(rangeStart, rangeEnd)
    } else {
      const rangeStart = moment(outerDate, "YYYY-MM-DD").startOf("month")
      const rangeEnd = moment(outerDate, "YYYY-MM-DD").endOf("month")
      syncRange(rangeStart, rangeEnd)
    }
  }, [outerDate])

  useEffect(() => {
    setTimeout(() => {
      calendarRef.current?.getApi().render()
    }, 500)
  }, [miniSidenav])

  const [date, setDate] = useState(null)

  useEffect(() => {
    setDate(outerDate)
  }, [outerDate])

  const _title = useMemo(() => {
    if (view === "dayGridMonth") {
      if (date) {
        return moment(date).format("MMMM YYYY")
      }
      const current = calendarRef.current?.getApi()?.currentData?.currentDate
      return moment(current).format("MMMM YYYY")
    }

    if (date) {
      return `${moment(date).startOf("isoWeek").format("Do")} ${
        moment(date).startOf("isoWeek").format("MMMM") !==
        moment(date).endOf("isoWeek").format("MMMM")
          ? moment(date).startOf("isoWeek").format("MMMM")
          : ""
      } - ${moment(date).endOf("isoWeek").format("Do")} ${moment(date)
        .endOf("isoWeek")
        .format("MMMM")}`
    }
    const startDate = calendarRef.current?.getApi()?.view.currentStart
    const endDate = calendarRef.current?.getApi()?.view.currentEnd
    return `${moment(startDate).format("Do")} ${
      moment(startDate).format("MMMM") !== moment(endDate).format("MMMM")
        ? moment(startDate).format("MMMM")
        : ""
    } - ${moment(endDate).format("Do")} ${moment(endDate).format("MMMM")}`
  }, [calendarRef.current, view, title, date])

  const navigate = useNavigate()

  useEffect(() => {
    onChangeTab?.(tab)
  }, [tab, timezone])

  // Modal props
  const propsModalLeaveApplication = {
    isOpen: isOpenModalLeave,
    onClose: () => setIsOpenModalLeave(false),
    onSubmit: (data) => {
      setPayloadSubmit(data)
      setIsOpenModalLeave(false)
      setIsOpenModalLeaveRelatedInformation(true)
    },
    date: dataModalLeave,
  }

  async function submitLeave(form) {
    const selectedFiles = Array.isArray(form?.attachments)
      ? form.attachments
      : []

    // 1) Upload nếu có File mới
    const filesToUpload = pickUploadFiles(selectedFiles)

    let uploaded = []
    if (filesToUpload.length > 0) {
      const formData = new FormData()
      filesToUpload.forEach((file) => {
        formData.append("attachments", file)
      })

      uploaded = await uploadFile(formData)

      // uploaded items đúng format backend bạn đưa
    }

    // 2) Map attachments vào dto
    const attachments = [
      ...mapExistingUrlToDtoAttachments(selectedFiles),
      ...mapUploadedToDtoAttachments(uploaded),
    ]

    // 3) Dedup theo url (tránh trùng nếu UI lỡ giữ cả url + File)
    const seen = new Set()
    const dedupedAttachments = attachments.filter((a) => {
      const key = a.url
      if (!key) return false
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })

    // 4) Build dto submit
    const dto = {
      // ...form,
      leaveType: form?.leaveType?.value,
      startDate: moment(form.fromDate).format("YYYY-MM-DD"),
      endDate: moment(form.toDate).format("YYYY-MM-DD"),
      dayType: form.isHalfDay ? "HALF_DAY" : "FULL_DAY",
      reason: form.reason ?? "Medical leave",
      approverId: form.approver?.userId || form?.approver?.id,
      notificationRecipientIds: form.notifyTo?.map((u) => u.id),
      uploadedAttachments: dedupedAttachments,
    }

    return createLeaveRequest(dto).then((result) => {
      if (result?.error) {
        setIsSubmitSuccess(false)
        setErrorMessage(
          result?.error?.data?.data?.message || "Submit leave request failed"
        )
      } else {
        setIsSubmitSuccess(true)
      }
    })
  }

  const propsModalLeaveRelatedInformation = {
    isOpen: isOpenModalLeaveRelatedInformation,
    onClose: () => setIsOpenModalLeaveRelatedInformation(false),
    onSubmit: async () => {
      try {
        submitLeave(payloadSubmit)
      } catch (e) {
        setIsSubmitSuccess(false)
      }
      setIsOpenModalLeaveRelatedInformation(false)
      setIsOpenModalLeaveSubmitStatus(true)
    },
    dataRelatedInformation: dataRelatedInformation,
  }

  const propsModalLeaveAlert = {
    isOpen: isOpenModalLeaveAlert,
    onClose: () => setIsOpenModalLeaveAlert(false),
    onSubmit: () => {
      setIsOpenModalLeaveAlert(false)
      setIsOpenModalLeave(true)
    },
  }

  const propsModalLeaveAlertHoliday = {
    isOpen: isOpenModalLeaveAlertHoliday,
    onClose: () => setIsOpenModalLeaveAlertHoliday(false),
    onSubmit: () => {},
    isAlertHoliday: true,
  }

  const propsModalLeaveSubmitStatus = {
    isOpen: isOpenModalLeaveSubmitStatus,
    onClose: () => setIsOpenModalLeaveSubmitStatus(false),
    onSubmit: () => {
      setIsOpenModalLeaveSubmitStatus(false)
    },
    status: isSubmitSuccess,
    errorMessage,
  }

  return (
    <MDBox sx={calendarContainer} id="weekly" className={view}>
      <MDTypography
        sx={calendarTabMenuItemNote}
        onClick={() => openNewLms({ userId, type: "TEACHER" })}
      >
        Can’t see your schedule? No stress! Tap HERE to pull up your Class
        Schedule 🧭
      </MDTypography>

      <MDBox sx={calendarHeader}>
        <MDBox
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            height: 28,
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              "& > div": {
                height: 28,
                cursor: "pointer",
              },
            }}
          >
            <MDBox
              onClick={() => {
                calendarRef.current?.getApi().prev()
                setTitle(calendarRef.current?.getApi().view.title || "")
                const start = calendarRef.current?.getApi().view.activeStart
                const end = calendarRef.current?.getApi().view.activeEnd
                setDate(null)

                syncRange(start, end)
              }}
            >
              <Icon component={WeeklyPrevIcon} />
            </MDBox>
            <MDBox
              onClick={() => {
                calendarRef.current?.getApi().next()
                setTitle(calendarRef.current?.getApi().view.title || "")
                const start = calendarRef.current?.getApi().view.activeStart
                const end = calendarRef.current?.getApi().view.activeEnd
                setDate(null)
                syncRange(start, end)
              }}
            >
              <Icon component={WeeklyNextIcon} />
            </MDBox>
          </MDBox>

          <MDTypography variant="span" sx={calendarTitle}>
            {_title}
          </MDTypography>
        </MDBox>
        <MDBox
          sx={calendarTabMenu}
          className={classes.containerCalendarFilterTabs}
        >
          {tabs.map((_tab, index) => {
            return (
              <MDBox
                key={index}
                sx={(theme) =>
                  calendarTabMenuItem(theme, {
                    active: _tab.value === tab.value,
                  })
                }
                onClick={() => {
                  setTab(_tab)
                }}
              >
                <MDTypography sx={calendarTabMenuItemTitle}>
                  {_tab.label}
                </MDTypography>
              </MDBox>
            )
          })}
          <InfoIcon
            type={TooltipType.TYPE_2}
            teacherInfoIconBlock={teacherInfoIconBlock.FILTER_TABS}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWith4}
          />
        </MDBox>
      </MDBox>
      <MDBox sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <InfoIcon
          type={TooltipType.TYPE_2}
          teacherInfoIconBlock={teacherInfoIconBlock.WEEK_MONTH}
          color={TooltipIconColor.BLUE}
          className={classes.containerInfoIconWith3}
        >
          <MDBox
            sx={() => ({
              display: "flex",
              background: "gray",
              borderRadius: "4px",
              overflow: "hidden",
            })}
          >
            {viewOptions.map((viewOption) => (
              <MDBox
                key={viewOption.value}
                sx={() => ({
                  background: view === viewOption.value ? "#192d3d" : "#2576B9",
                  padding: "6px 12px",
                  cursor: "pointer",
                })}
                onClick={(e) => {
                  e.preventDefault()
                  onChangeViewOption(viewOption.value)
                }}
              >
                <MDTypography
                  sx={({ breakpoints }) => ({
                    ...noteTypography(breakpoints),
                    color: "#FFFFFF",
                  })}
                >
                  {viewOption.label}
                </MDTypography>
              </MDBox>
            ))}
            {/* <MDBox
              sx={() => ({
                background: view === "timeGridWeek" ? "#192d3d" : "#2576B9",
                padding: "6px 12px",
                cursor: "pointer",
              })}
              onClick={(value) => {
                if (value === view) return;
                setView("timeGridWeek");
                setIsActiveDayOff(value === "dayGridMonth");
                calendarRef.current?.getApi().changeView("timeGridWeek");
                calendarRef.current?.getApi().render();
              }}
            >
              <MDTypography
                sx={({ breakpoints }) => ({
                  ...noteTypography(breakpoints),
                  color: "#FFFFFF",
                })}
              >
                Week
              </MDTypography>
            </MDBox>
            <MDBox
              sx={() => ({
                background: view === "dayGridMonth" ? "#192d3d" : "#2576B9",
                padding: "6px 12px",
                cursor: "pointer",
              })}
              onClick={() => {
                setView("dayGridMonth");
                calendarRef.current?.getApi().changeView("dayGridMonth");
                calendarRef.current?.getApi().render();
              }}
            >
              <MDTypography
                sx={({ breakpoints }) => ({
                  ...noteTypography(breakpoints),
                  color: "#FFFFFF",
                })}
              >
                Month
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </InfoIcon>
      </MDBox>
      <MDBox
        sx={({ functions: { pxToRem } }) => ({
          overflowX: "auto",
          marginBottom: pxToRem(16),
        })}
      >
        <MDBox
          minWidth="100%"
          sx={({ breakpoints, functions: { pxToRem } }) => ({
            maxWidth: "100%",
            width: pxToRem(800),
            [breakpoints.down(1600)]: {
              width: pxToRem(600),
            },
          })}
        >
          <FullCalendar
            // <editor-fold desc="Calendar props"/>
            ref={calendarRef}
            locale={enUS}
            datesSet={({ view }) => {
              if (view?.type === "timeGridWeek") {
                const start = view.currentStart || view.activeStart
                if (start) {
                  lastWeekDateRef.current = moment
                    .utc(start)
                    .format("YYYY-MM-DD")
                }
              }
              if (view?.type === "dayGridMonth") {
                const monthStart = view.currentStart || view.activeStart
                if (monthStart) {
                  currentMonthRef.current = moment
                    .utc(monthStart)
                    .format("YYYY-MM")
                  monthAnchorDateRef.current = moment
                    .utc(monthStart)
                    .add(10, "days")
                    .format("YYYY-MM-DD")
                }
              }
              const rangeStart = view?.currentStart || view?.activeStart
              const rangeEnd = view?.currentEnd || view?.activeEnd
              if (rangeStart && rangeEnd) {
                syncRange(rangeStart, rangeEnd)
              }
            }}
            viewDidMount={({ view }) => {
              setTitle(view.title)
              const start = view.activeStart
              const end = view.activeEnd
              syncRange(start, end)
            }}
            eventClick={(info) => {
              setData(info.event)
              setOpen(true)
            }}
            height="auto"
            titleFormat={(info) => {
              const startDate = info.start.marker
              const endDate = info.end?.marker

              return `${moment(startDate).format("Do")} ${
                moment(startDate).format("MMMM") !==
                moment(endDate).format("MMMM")
                  ? moment(startDate).format("MMMM")
                  : ""
              } - ${moment(endDate).format("Do")} ${moment(endDate).format(
                "MMMM"
              )}`
            }}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            timeZone="UTC"
            initialView={view}
            headerToolbar={false}
            allDaySlot={false}
            firstDay={1}
            scrollTimeReset={true}
            slotDuration="01:00:00"
            scrollTime="09:00:00"
            dayHeaderContent={({ date }) => {
              let event = []
              for (let i in eventsByDay) {
                if (moment(i).isSame(moment(date), "day")) {
                  event = eventsByDay[i]
                  break
                }
              }
              const isToday = moment(date).isSame(moment(), "day")
              const isWeekends = moment(date).clone().day() % 6 === 0
              return (
                <MDBox sx={calendarDayHeader}>
                  <MDTypography
                    sx={(theme) =>
                      calendarDayTopHeader(theme, {
                        isToday,
                        isWeekends,
                      })
                    }
                  >
                    {moment(date).format("ddd")}
                  </MDTypography>
                  {view !== "dayGridMonth" ? (
                    <MDTypography
                      sx={(theme) =>
                        calendarDayBottomHeader(theme, {
                          isToday,
                          isWeekends,
                        })
                      }
                    >
                      {moment(date).format("DD")}
                    </MDTypography>
                  ) : null}
                  {/*{event.length ? <Deadline numOfDeadlines={event.length} /> : <></>}*/}
                </MDBox>
              )
            }}
            slotLabelContent={({ date }) => {
              return (
                <MDTypography sx={calendarSlotLabel}>
                  {moment(date).utc().format("H:mm")}
                </MDTypography>
              )
            }}
            events={loading ? [] : [...events]}
            eventContent={(arg) => {
              const time = arg.event.extendedProps.deadline || arg?.event?.start
              const groupKOC = arg.event.extendedProps?.data?.groupKoc

              return (
                <MDBox
                  sx={{
                    width: "100%",
                    backgroundColor: `${arg.backgroundColor}`,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    cursor: "pointer",
                    padding: "2px 6px",
                    position: "relative",
                  }}
                >
                  <MDBox>
                    <MDTypography
                      sx={({ breakpoints }) => ({
                        ...noteTypography(breakpoints),
                      })}
                    >
                      {/* {moment(time).format("HH:mm")} */}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={({ breakpoints }) => ({
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      ...descriptionTypography(breakpoints),
                      position: "relative",
                      zIndex: 2,
                    })}
                  >
                    {arg.event.title}
                  </MDBox>

                  {groupKOC && (
                    <MDBox>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...noteTypography(breakpoints),
                          position: "absolute",
                          right: 0,
                          top: 0,
                          fontSize: 8,
                          backgroundColor:
                            groupKOC === "ATLS" ? "#CA6A7A" : "#192d3d",
                          padding: "2px 4px",
                          borderRadius: "4px",
                          color: "white !important",
                          zIndex: 1,
                        })}
                      >
                        {groupKOC}
                      </MDTypography>
                    </MDBox>
                  )}

                  <MDBox></MDBox>
                </MDBox>
              )
            }}
            dayCellContent={(arg) => {
              const { dow, dayNumberText, view, isDisabled } = arg
              const viewType = view.type

              const cellDate =
                arg.dateStr ?? moment(arg.date).format("YYYY-MM-DD")

              const effectiveLeaveData = leaveDataProp ?? leaveData
              const matched = effectiveLeaveData?.data?.calendarDays?.findIndex(
                (item) => item.date === cellDate
              )
              const isActiveDayOff =
                effectiveLeaveData?.data?.calendarDays[matched]?.color ===
                "GREEN"

              return (
                <>
                  {viewType !== "dayGridMonth" || isDisabled ? (
                    <MDBox className="view-normal">{dayNumberText}</MDBox>
                  ) : (
                    <MDBox
                      className={`view-${viewType} ${
                        isActiveDayOff ? "activeDayOff" : ""
                      }`}
                      sx={dayCellStyle(isActiveDayOff, dow)}
                      onClick={(e) => {
                        e.stopPropagation()

                        const api = calendarRef.current?.getApi()
                        const dayEvents =
                          api
                            ?.getEvents()
                            ?.filter((ev) =>
                              moment(ev.start).isSame(arg.date, "day")
                            ) ?? []
                        const array = dayEvents.map((item) => {
                          return {
                            event: item.extendedProps,
                          }
                        })
                        setDataRelatedInformation(array)
                        onClickForDayGridMonth(isActiveDayOff)
                      }}
                    >
                      {dayNumberText}
                    </MDBox>
                  )}
                </>
              )
            }}
            // </editor-fold />
          />
        </MDBox>
      </MDBox>
      {data?.extendedProps?.type === "Training/Workshop" ? (
        <ModalWorkShop
          isOpen={isOpen}
          onClose={() => {
            setOpen(false)
            setData({})
          }}
          data={data}
        />
      ) : data?.extendedProps?.type === TypeClassSession.STUDENTS_AT_RISK ? (
        <ModalMyCalendarStudentAtRisk
          isOpen={isOpen}
          setOpen={setOpen}
          icon={modalCalendarIcon}
          onClose={() => {
            setOpen(false)
            setData({})
          }}
          dataExtendedProps={data?.extendedProps}
          dispatch={dispatch}
        />
      ) : (
        <Modal
          open={isOpen}
          onClose={() => {
            setOpen(false)
            setData({})
          }}
        >
          <MDBox sx={{ ...style }}>
            <MDBox display="flex" gap={1} alignItems="center" mb={3}>
              <MDBox
                sx={{
                  width: 48,
                  height: 48,
                  background: "#2576B9",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                }}
              >
                <MDBox
                  sx={{ width: 29 }}
                  component="img"
                  src={modalCalendarIcon}
                ></MDBox>
              </MDBox>
              <MDBox>
                <MDTypography
                  sx={({ breakpoints }) => ({
                    ...titleTypography(breakpoints),
                    lineHeight: 1.37,
                  })}
                >
                  Details
                </MDTypography>
                <MDTypography
                  sx={({ breakpoints }) => ({
                    ...noteTypography(breakpoints),
                    lineHeight: 1.5,
                  })}
                >
                  Type: {data?.extendedProps?.type}
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: 1,
              }}
            >
              {
                <>
                  {data?.extendedProps?.data?.className ? (
                    <MDTypography
                      sx={({ breakpoints }) => ({
                        ...descriptionTypography(breakpoints),
                        lineHeight: 1.5,
                      })}
                    >
                      Class name: {data?.extendedProps?.data?.className}{" "}
                    </MDTypography>
                  ) : null}
                  <MDTypography
                    sx={({ breakpoints }) => ({
                      ...descriptionTypography(breakpoints),
                      lineHeight: 1.5,
                    })}
                  >
                    {data?.extendedProps?.type === "Lesson"
                      ? `Center name: ${
                          data?.extendedProps?.data?.centerName ?? ""
                        }`
                      : ""}
                    {data?.extendedProps?.type === "Feedback"
                      ? `Feedback subject: ${
                          data?.extendedProps?.data?.feedBackSubject ?? ""
                        }`
                      : ""}
                    {/* {data?.extendedProps?.type === "PT/Demo"
                ? `Center name: ${data?.extendedProps?.data?.centerName ?? ""}`
                : ""} */}
                    {data?.extendedProps?.type === "Daily Report"
                      ? `Session name: ${
                          data?.extendedProps?.data?.sessionName ?? ""
                        }`
                      : ""}
                    {data?.extendedProps?.type === "Progress Report" ? (
                      <MDBox
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          gap: 1,
                        }}
                      >
                        <p>
                          Class name:{" "}
                          {data?.extendedProps?.progressReportsClassName ?? ""}
                        </p>
                        <p>
                          Number of reports:{" "}
                          {data?.extendedProps?.data.length ?? 0}
                        </p>
                      </MDBox>
                    ) : (
                      ""
                    )}
                    {data?.extendedProps?.type === "Gradebook Report" ? (
                      <MDBox
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          gap: 1,
                        }}
                      >
                        <p>
                          Class name:{" "}
                          {data?.extendedProps?.gradeBookReportsClassName ?? ""}{" "}
                        </p>
                        <p>
                          Number of reports:{" "}
                          {data?.extendedProps?.data.length ?? 0}
                        </p>
                      </MDBox>
                    ) : (
                      ""
                    )}
                    {data?.extendedProps?.type === "EOCC & Test"
                      ? `Event: ${data?.extendedProps?.data?.event ?? ""}`
                      : ""}
                  </MDTypography>
                  {data?.extendedProps?.deadline ? (
                    <MDTypography
                      sx={({ breakpoints }) => ({
                        ...descriptionTypography(breakpoints),
                        lineHeight: 1.5,
                      })}
                    >
                      Deadline:{" "}
                      {moment(data?.extendedProps?.deadline).format(
                        "DD-MM-YYYY HH:mm"
                      )}
                    </MDTypography>
                  ) : data?.extendedProps?.type === "PT/Demo" ? (
                    <>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Center: {data?.extendedProps?.data?.centerName}
                      </MDTypography>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Event: {data?.extendedProps?.data?.eventName}
                      </MDTypography>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Event Type: {data?.extendedProps?.data?.eventTypeName}
                      </MDTypography>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Teacher: {data?.extendedProps?.data?.fullNameEN}
                      </MDTypography>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Start time:{" "}
                        {moment(data?.start)
                          .add(-7, "h")
                          .format("DD-MM-YYYY HH:mm")}
                      </MDTypography>
                      {data?.end ? (
                        <MDTypography
                          sx={({ breakpoints }) => ({
                            ...descriptionTypography(breakpoints),
                            lineHeight: 1.5,
                          })}
                        >
                          End time:{" "}
                          {moment(data?.end)
                            .add(-7, "h")
                            .format("DD-MM-YYYY HH:mm")}
                        </MDTypography>
                      ) : null}
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Number of appointments:{" "}
                        {data.extendedProps.data.appointment}
                      </MDTypography>
                    </>
                  ) : (
                    <>
                      <MDTypography
                        sx={({ breakpoints }) => ({
                          ...descriptionTypography(breakpoints),
                          lineHeight: 1.5,
                        })}
                      >
                        Start time:{" "}
                        {moment(data?.start)
                          .add(-7, "h")
                          .format("DD-MM-YYYY HH:mm")}
                      </MDTypography>
                      {data?.end ? (
                        <MDTypography
                          sx={({ breakpoints }) => ({
                            ...descriptionTypography(breakpoints),
                            lineHeight: 1.5,
                          })}
                        >
                          End time:{" "}
                          {moment(data?.end)
                            .add(-7, "h")
                            .format("DD-MM-YYYY HH:mm")}
                        </MDTypography>
                      ) : null}
                    </>
                  )}
                </>
              }
            </MDBox>
            <MDBox
              sx={{
                mt: 3,
                color: "#FFFFFF",
                fontFamily: "Lexend, san-serif",
                textTransform: "unset",
                width: "350px",
                maxWidth: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
              }}
              role={undefined}
              tabIndex={-1}
            >
              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  color: "#FFFFFF",
                  backgroundColor: "#2576B9",
                  fontFamily: "Lexend, san-serif",
                  textTransform: "unset",
                  width: "-webkit-fill-available",
                }}
                role={undefined}
                tabIndex={-1}
                onClick={() => {
                  const type = data?.extendedProps?.type
                  const item = data?.extendedProps?.data
                  if (
                    type === "EOCC & Test" ||
                    type === "Lesson" ||
                    type === "PT/Demo" ||
                    type === "Training"
                  ) {
                    setOpen(false)
                    return
                  }

                  let itemNew = item
                  if (item && item.length) {
                    itemNew = item[0]
                  }
                  const id =
                    type === "Feedback"
                      ? itemNew?.feedback?.feedBackId
                      : type === TypeClassSession.STUDENTS_AT_RISK
                      ? itemNew?.id
                      : type === "Daily Report"
                      ? itemNew.dailyReportId
                      : type === "Progress Report"
                      ? itemNew.progressReportId
                      : type === "Gradebook Report"
                      ? itemNew.gradeBookReportId
                      : null
                  console.log(id, "id")

                  navigate(
                    `/assistant/my-tasks?id=${id}&start=${
                      data?.start
                        ? moment(data?.start).add(-7, "h").format("MM-DD-YYYY")
                        : ""
                    }&end=${
                      data?.end
                        ? moment(data?.end).add(-7, "h").format("MM-DD-YYYY")
                        : ""
                    }&type=${type}`
                  )
                }}
              >
                {data?.extendedProps?.type === "EOCC & Test" ||
                data?.extendedProps?.type === "Lesson" ||
                data?.extendedProps?.type === "PT/Demo"
                  ? "OK"
                  : "Go to To-do list"}
              </Button>
              {data?.extendedProps?.type === "Lesson" ? (
                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    color: "#FFFFFF",
                    backgroundColor: "#2576B9",
                    fontFamily: "Lexend, san-serif",
                    textTransform: "unset",
                    width: "-webkit-fill-available",
                  }}
                  component="label"
                  role={undefined}
                  tabIndex={-1}
                  onClick={async (e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    const dataProps = data?.extendedProps?.data
                    await handleOpenLms({
                      data: dataProps,
                      userId,
                      type: "LESSON_DETAIL",
                    })
                  }}
                >
                  GO TO LMS
                </Button>
              ) : data?.extendedProps?.type === "PT/Demo" ? (
                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    color: "#FFFFFF",
                    backgroundColor: "#2576B9",
                    fontFamily: "Lexend, san-serif",
                    textTransform: "unset",
                    width: "-webkit-fill-available",
                  }}
                  component="label"
                  role={undefined}
                  tabIndex={-1}
                  onClick={async () => {
                    const res = await getHub({
                      redirectURL: `http://hub24.apollo.vn:7777/event/ptonline`,
                    })
                    const _data = res?.data?.data
                    if (_data) {
                      window.open(_data, "_blank")
                    }
                  }}
                >
                  GO TO HUB
                </Button>
              ) : data?.extendedProps?.type !== "EOCC & Test" &&
                data?.extendedProps?.type !== "Training" ? (
                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    color: "#FFFFFF",
                    backgroundColor: "#2576B9",
                    fontFamily: "Lexend, san-serif",
                    textTransform: "unset",
                    width: "-webkit-fill-available",
                  }}
                  component="label"
                  role={undefined}
                  tabIndex={-1}
                  onClick={async () => {
                    setOpen(false)
                  }}
                >
                  OK
                </Button>
              ) : null}
            </MDBox>
          </MDBox>
        </Modal>
      )}

      {isOpenModalLeave && (
        <ModalLeaveApplication {...propsModalLeaveApplication} />
      )}
      {isOpenModalLeaveAlert && <ModalLeaveAlert {...propsModalLeaveAlert} />}
      {isOpenModalLeaveAlertHoliday && (
        <ModalLeaveAlert {...propsModalLeaveAlertHoliday} />
      )}
      {isOpenModalLeaveRelatedInformation && (
        <ModalLeaveRelatedInfomation {...propsModalLeaveRelatedInformation} />
      )}
      {isOpenModalLeaveSubmitStatus && (
        <ModalLeaveSubmitStatus {...propsModalLeaveSubmitStatus} />
      )}
    </MDBox>
  )
}

export default WeeklyCalendar
